import { Actionsheet as NbActionsheet } from '@fhs-legacy/native-base';

import { addWithConfig } from '../../utils';

export const Actionsheet = NbActionsheet;

export default addWithConfig(Actionsheet);
